var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"alert-tooltip z-10 aisea-text-14-400-white pl-1"},[_c('div',{staticClass:"alert-title"},[_vm._t("alert-title")],2),_c('div',{staticClass:"alert-item"},[_vm._t("alert-item")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }